export default __webpack_public_path__ + "static/media/master-data.f88cd354.webp";